type MessageId =
  | 'ready'
  | 'game.session.end'
  | 'autoplay.stop'
  | 'game.enable'
  | 'game.balance.reload'
  | 'audio.enable'
  | 'audio.disable';

export enum DgcReceivingEvents {
  INITIALISE_EVENT = 'gel.initialise',
  READY = 'gel.ready',
  CLOSE = 'gel.close',
  SPIN_START = 'gel.spin.start',
  SPIN_END = 'gel.spin.end',
  ALERT_ACTION = 'gel.alert.action',
  SOUND_ON = 'gel.audio.enable',
  SOUND_OFF = 'gel.audio.disable',
  WARNING = 'gel.dgc.warning',
  FATAL_ERROR = 'gel.dgc.fatalError',
}

export enum DgcSendingEvents {
  OPERATOR_READY = 'operator.ready',
  GAME_SESSION_END = 'operator.game.session.end',
  STOP_AUTOPLAY = 'operator.autoplay.stop',
  RESUME_AUTOPLAY = 'operator.game.enable',
  BALANCE_RELOAD = 'operator.game.balance.reload',
  ENABLE_AUDIO = 'operator.audio.enable',
  DISABLE_AUDIO = 'operator.audio.disable',
}

type OperatorMessageType = `operator.${MessageId}`;

export type DGCMessageOperator = {
  method: OperatorMessageType;
} & Record<string, unknown>;

export type OperatorMessageEvent = MessageEvent<DGCMessageOperator>;
